import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import db from "./utils/localstorage.js";
router.beforeEach((to, form, next) => {
	if (to.path == "/login") {
		store.commit("clearUser");
		next();
	} else {
		let token = to.query.foreignToken || store.state.user.token;
		if (to.query && to.query.foreignToken && to.query.foreignToken != db.get("token")) {
			store.commit("SET_TOKEN", to.query.foreignToken);
			// db.save('userInfo',data)
			db.save("token", to.query.foreignToken);
			db.save('jumpLocation',to.query.foreignToken)
			setTimeout(() => {
				window.location.reload();
			}, 800);
			return;
		}
		if (!token && to.path != "/login") {
			next({ path: "/login" });
		} else {
			if (store.getters.roles && store.getters.roles.length === 0) {
				// 判断当前用户是否已拉取完user_info信息
				// console.log()
				store
					.dispatch("GetInfo")
					.then((res) => {
						// 拉取user_info

						const roles = res.roles;
						store.dispatch("GenerateRoutes", { roles }).then((accessRoutes) => {
							// 测试 默认静态页面
							// store.dispatch('permission/generateRoutes', { roles }).then(accessRoutes => {
							// 根据roles权限生成可访问的路由表
							router.addRoutes(accessRoutes); // 动态添加可访问路由表
							next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
						});
						next({ ...to, replace: true });
					})
					.catch((err) => {
						// alert(err )
						// store.dispatch('FedLogOut').then(() => {
						//   Message.error(err)
						//   next({ path: '/' })
						// })
					});
			} else {
				next();
				// 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
				// if (hasPermission(store.getters.roles, to.meta.roles)) {
				//   next()
				// } else {
				//   next({ path: '/401', replace: true, query: { noGoBack: true }})
				// }
				// 可删 ↑
			}
		}
	}
});
